import PrivacyView from './Privacy.View';

const Privacy = () => <PrivacyView />;

export default Privacy;
